import { waitForDatabaseUserId } from "./CurrentUser";
interface PinnedCard {
    type: string;
    elementGuid: string;
    name: string;
}

export interface PoiCustomTags {
    tags: Record<string, string[]>;
}

export interface UserSettingsDTO {
    userId: string;
    prefix: string;
    settingsJson: string;
}

export interface UserDTO {
    userName: string;
    email: string;
    fullName: string;
}
type CustomTags = Record<string, string[]>;


export async function FetchUserCards(): Promise<PinnedCard[] | null> {
    const userCards = await getSettings<PinnedCard[]>("dashboard");
    if (!userCards) {
        return null;
    }
    const obj = JSON.parse(userCards as unknown as string);
    return obj.cards
}

export async function FetchPoiCustomTags(testName: string): Promise<string[] | null> {
    const poiTags = await getSettings<PoiCustomTags>("poiTags");
    if (!poiTags) {
        return null;
    }
    const obj = JSON.parse(poiTags as unknown as string);
    const filtered = obj[testName];
    return filtered ? filtered : null;
}



export async function CreateUser(user: UserDTO) {

    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/users/create`;

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(user)
        });

        if (!response.ok) {
            console.error(`Failed to create user. Status: ${response.status}`);
            return null;
        }

        const data = (await response.text()).trim().replace(/^"|"$/g, "");
        const userId = Number(data);
        if (!data || Number.isNaN(userId)) {
            console.error("Unexpected response when creating user:", data);
            return null;
        }
        return userId.toString();
    } catch (error) {
        console.error("Failed to create user", error);
        return null;
    }
}



export async function getSettings<T>(prefix: string): Promise<T | null> {
    const userId = await waitForDatabaseUserId();
    if (!userId) {
        console.warn(`Cannot load user settings "${prefix}": the user is not registered.`);
        return null;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/usersettings/${userId}?prefix=${prefix}`;

    try {
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) {
            console.warn("No user settings found or request failed.");
            return null;
        }

        const text = await response.text();
        if (!text) {
            console.warn("Empty response body.");
            return null;
        }

        try {
            return JSON.parse(text) as T;
        } catch (parseError) {
            console.error("Failed to parse JSON:", parseError);
            return null;
        }
    } catch (err: any) {
        console.error("Error fetching user settings:", err.message);
        return null;
    }
}



export async function upsertSettings<T>(
    prefix: string,
    data: T
): Promise<boolean> {
    // Serialize before the first await: callers such as Redux reducers pass Immer drafts,
    // which are revoked as soon as the reducer returns.
    const settingsJson = JSON.stringify(data);

    const userId = await waitForDatabaseUserId();
    if (!userId) {
        console.warn(`Cannot save user settings "${prefix}": the user is not registered.`);
        return false;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/usersettings/upsert`;
    const payload: UserSettingsDTO = {
        userId,
        prefix,
        settingsJson,
    };

    try {
        const response = await fetch(url, {
            method: "POST", // or PUT, depending on your backend
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            console.warn("Failed to upsert user settings. Status:", response.status);
            return false;
        }

        return true;
    } catch (err: any) {
        console.error("Error upserting user settings:", err.message);
        return false;
    }
}



